import React, { useState } from "react";
import Spinner from "../../images/Spinner.gif";
import { LoadingOutlined, SyncOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import "../../common/form.css";

const UseFullLoader = () => {
  const [loading, setLoading] = useState(false);
  return [
    loading ? (
      <div className="fp-container">
        <Spin
          size="large"
          className="fp-loader"
          indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
        ></Spin>
        {/* <SyncOutlined spin className="fp-loader" style={{ color: "#00d8db" }} /> */}
        {/* <LoadingOutlined style={{ color: "#00d8db" }} /> */}
        {/* <img src={Spinner} className="fp-loader" alt="loading" /> */}
      </div>
    ) : null,
    () => setLoading(true), //Show Loader
    () => setLoading(false), //Hide Loader
  ];
};

export default UseFullLoader;
